import type { EnvironmentId, ThreadId } from "@cmmd-forge/contracts";
import { newCommandId } from "~/lib/utils";
import { runThreadExecutionIntentAction } from "~/lib/runThreadExecutionIntentAction";

export async function updateRemoteThreadGoal(input: {
  readonly environmentId: EnvironmentId;
  readonly runtimeId: string;
  readonly threadId: ThreadId;
  readonly goal: string | null;
}): Promise<void> {
  const commandId = newCommandId();
  await runThreadExecutionIntentAction(
    input.environmentId,
    {
      runtimeId: input.runtimeId,
      projectId: null,
      action: "wake",
      targetId: null,
      dispatchIdentity: commandId,
    },
    {
      dispatch: (api) =>
        api.orchestration.dispatchCommand({
          type: "thread.meta.update",
          commandId,
          threadId: input.threadId,
          goal: input.goal,
        }),
    },
  );
}
